import axios from "axios";
import router from "@/router"
import {Storage} from "@/Services/Storage";
import {errorHandler} from "../../Services/errorHandler";


export default {
    name: 'payment_requests',
    state: {},
    getters: {},
    mutations: {},
    actions: {
        makeExpenseRequest: async (context, formData) => {
            let user = await Storage.getCurrentUser();
            formData.user = user.Username;
            return axios.post(paymentApi + `makeRequest`, formData)
        },

        getAllPendingRequests: async (context, searchQuery) => {
            let user = await Storage.getCurrentUser();
            let obj = searchQuery
            obj.userType = user.Type;
            return axios.get(paymentApi + `getAllPendingRequests`, {
                params: obj
            }).then(({data}) => data).catch(err => errorHandler.tomcatError(err))
        },
        getUserHistory: async (context, searchQuery) => {
            let user = await Storage.getCurrentUser();
            let obj = searchQuery
            obj.currentUser = user.Username;
            return axios.post(paymentApi + `searchHistory`, obj)
                .then(({data}) => data).catch(err => errorHandler.tomcatError(err))
        },
        authorizeRequest: async (context, payload) => {
            let user = await Storage.getCurrentUser();
            let obj = {
                id: payload.id,
                authorizedBy : user.Username,
                method : payload.method,
            };
            return axios.post(paymentApi + `authorizeRequest`, obj)
                .catch(err => errorHandler.tomcatError(err))
        },
        denyRequest: async (context, obj) => {
            let user = await Storage.getCurrentUser();
             obj = {
                denyReason : obj.denyReason,
                deniedBy : user.Username,
                id : obj.id,
            };
            return axios.post(paymentApi + `denyRequest`, obj)
                .catch(err => errorHandler.tomcatError(err))
        },
        // GINGER-20260628: Phase 2 of Kazang 2FA flow. Backend Phase 1 returned 202 + OtpRequiredResponse;
        // merchant typed the OTP from WhatsApp; we POST it here to /confirm-otp. Throws on non-2xx so
        // caller can branch on 401 (re-prompt), 429 (rate limit with retryAfter), or 5xx.
        // See docs/gap_analysis_petty_cash_otp_modal.md
        confirmOtpForUserRequest: async (context, payload) => {
            // payload = { userRequestId: number, otp: string }
            return axios.post(
                `${ticketApi2}transaction-handler/approve-user-request/${payload.userRequestId}/confirm-otp`,
                { otp: payload.otp }
            ).then(({ data }) => data)
              .catch(err => errorHandler.tomcatError(err));
        }


    }
}

